import React from "react";
import { connect } from "react-redux";
import "../../styles/Empresa.css";
import VistaPdf from '../documentViewer/VistaPdf'
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import { Link } from "react-router-dom";
import { getRecibos } from "./ReportesService"
import { idEmpresa, URL } from "../../constans/constants"
import { Button, Container, Row, Col, Modal, Form } from "react-bootstrap";
import arrowBack from '../../styles/icons/arrow_back.svg';
import pdfIcon from '../../styles/icons/pdf.svg'
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";

class ReporteRecibos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Ingrese Pin de Firma",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedRecibo: {
        recibo: "",
        idLote: "",
        numeroLote: "",
        tipoDocumento: "",
        fechaCarga: "",
        empleado: "",
        estado: "",
        estadoMTESS: false
      },
      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      dialogPinOpen: false,
      open: false,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      severityFlash: "",

      loading:true,
      search:"",
      page: 0,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
    };
    let pantallaAnterior = null;
    this.setPantallaAnterior();
    this.tableRef = React.createRef();

  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading) {
      this.tableRef.current && this.tableRef.current.onQueryChange();
    }
  }

  setPantallaAnterior = () => {
    localStorage.setItem("urlAnterior", window.location.href);
    this.pantallaAnterior = (localStorage.getItem("urlRaiz")).substring(localStorage.getItem("urlRaiz").indexOf("#"));
}

  handleDialog = (value) => {
    this.setState({
      dialogIsOpen: value,
    });
  };
  descargarRecibos = () => {
    if (this.props.match.params.estado) {
      window.location.href = URL + "reportes/recibos/descargar?usuario=" + this.props.match.params.id + "&idEmpresa=" + idEmpresa() + "&estado=" + this.props.match.params.estado;
    } else {
      window.location.href = URL + "reportes/recibos/descargar?usuario=" + this.props.match.params.id + "&idEmpresa=" + idEmpresa();
    }

  }
  descargarRecibosXls = () => {
    if (this.props.match.params.estado) {
      window.location.href = URL + "reportes/recibos/descargar/xls?usuario=" + this.props.match.params.id + "&idEmpresa=" + idEmpresa() + "&estado=" + this.props.match.params.estado;
    } else {
      window.location.href = URL + "reportes/recibos/descargar/xls?usuario=" + this.props.match.params.id + "&idEmpresa=" + idEmpresa();
    }

  }

  handleDialogPin = (value, mensaje = "", severity = "") => {
    this.setState({
      dialogPinOpen: value,
      mostrarMensajeFlash: true,
      mensajeFlash: mensaje,
      severityFlash: severity
    });
  };
  handleClose = (value) => {
    this.setState({
      open: value
    });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };
  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchRecibos(newPage, this.state.pageSize, "");
      });
    }
  }
  componentDidMount() {
    this.fetchRecibos(0, this.state.pageSize, "");
  }
  
  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchRecibos(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchRecibos(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">1</a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">{totalPages}</a>
          </li>
        );
      }
    }

    return pages;
  }



  fetchRecibos(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getRecibos(page, pageSize, search, this.props.match.params.id, this.props.match.params.estado).then(() => {
      this.setState({
        recibos: this.props.reporteReciboData.reporteRecibo,
        page: this.props.reporteReciboData.page,
        totalCount: this.props.reporteReciboData.totalCount,
        totalPages: Math.ceil(this.props.reporteReciboData.totalCount / pageSize),
        loading: false 
      });
    });
  }
  
  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchRecibos(0, this.state.pageSize, this.state.search);
    });
  };

render() {
  return (
    <div className="template-base">
      <header className="component-header">
        <div className="page-container">
          <nav className="breadcrumb-page">
            <a className="btn-small btn-primary-tonal-outline btn-icon" onClick={() => window.location.href = this.pantallaAnterior}>
              <span className="material-symbols-outlined">arrow_back</span>
            </a>
            <span className="current">Recibos de {this.props.match.params.colaborador}</span>
          </nav>

          <div className="head-area">
            <div className="caption-area">
              <h1 className="page-title">Recibos de {this.props.match.params.colaborador}</h1>
              <p className="page-description">Listado de recibos disponibles por colaborador</p>
            </div>
            <div className="head-actions">
              <a className="btn-medium btn-base-outline" onClick={this.descargarRecibos}>
                <span className="material-symbols-outlined">download</span> Descargar ZIP
              </a>
              <a className="btn-medium btn-primary" onClick={this.descargarRecibosXls}>
                <span className="material-symbols-outlined">history_edu</span> Descargar XLS
              </a>
            </div>
          </div>
        </div>
      </header>
          <div className="wrapperContainer">
            <div className="page-container">
     <div className="component-table">
            <div className="component-pagination">
              <div className="pagination-actions">
            <form className="search-form form">
              <div className="search-group">
                <div className="input-icon">
                  <span className="material-symbols-outlined">search</span>
                </div>
                <input
                  type="search"
                  className="input-search"
                  placeholder="Buscar.."
                  aria-label="Search"
                  value={this.state.search}
                  onChange={this.handleSearchChange}
                />
              </div>
            </form>
    
            <div className="pagination">
              <span className="info-pages">
                {this.state.page * this.state.pageSize + 1}-
                {Math.min(
                  (this.state.page + 1) * this.state.pageSize,
                  this.state.totalCount
                )}{" "}
                de {this.state.totalCount}
              </span>

              <button
                className={`btn-prev ${this.state.page === 0 ? "btn-disabled" : ""
                  }`}
                onClick={() => this.handlePageChange(this.state.page - 1)}
                disabled={this.state.page === 0}
              >
                <span className="material-symbols-outlined">navigate_before</span>
              </button>

              <button
                className={`btn-next ${this.state.page === this.state.totalPages - 1
                  ? "btn-disabled"
                  : ""
                  }`}
                onClick={() => this.handlePageChange(this.state.page + 1)}
                disabled={this.state.page === this.state.totalPages - 1}
              >
                <span className="material-symbols-outlined">navigate_next</span>
              </button>
            </div>
              </div>
            </div>
    
            <div className="responsive-table">
              <table>
                <thead>
                  <tr>
                    <th>Recibo</th>
                    <th>Lote</th>
                    <th>Concepto</th>
                    <th>Fecha</th>
                    <th>Tipo Documento</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {this.loading ? (
                    <tr>
                      <td colSpan="6">Cargando...</td>
                    </tr>
                  ) : this.props.reporteReciboData.reporteRecibo.length === 0 ? (
                    <tr>
                      <td colSpan="6">No se encontraron resultados</td>
                    </tr>
                  ) : (
                    this.props.reporteReciboData.reporteRecibo.map((recibo, index) => (
                      <tr key={index}>
                          <td>{recibo.recibo}</td>
                          <td>{recibo.numeroLote}</td>
                          <td>{recibo.descripcionLote}</td>
                          <td>{recibo.fechaCarga}</td>
                          <td>{recibo.tipoDocumento}</td>
                        <td>
                            <span className="label__info">
                                {recibo.estado}
                            </span>
                        </td>
                        <td>{recibo.estadoMTESS ? "Sí" : "No"}</td>
                        <td>
                          <div className="table-actions">
                            <Link to={`/reporte/nro-recibo/${recibo.recibo}/nro-lote/${recibo.idLote}/ver`}>
                              <button className="table-icon">
                                <img src={pdfIcon} alt="ver_pdf" />
                              </button>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
          </div>
          </div>
      <Modal
        fullWidth
        maxWidth="md"
        show={this.state.dialogIsOpen}
        onHide={this.handleDialog}
      >
        <VistaPdf
          idLote={this.state.selectedRecibo.idLote}
          recibo={this.state.selectedRecibo}
          handleClose={this.handleDialogVerDatos}
          type={this.state.dialogType}
          submitText={this.state.submitText}
          disabledInput={this.state.disabledInput}
        />
      </Modal>

      <MensajeFlash
        mensaje={this.state.mensajeFlash}
        severity={this.state.severityFlash}
        open={this.state.mostrarMensajeFlash}
        handleClose={this.handleCloseMensajeFlash}
      />
    </div>
  );
}}


const mapDispatchToProps = (dispatch) => ({
  getRecibos: (page, size, search, usuario, estado) => dispatch(getRecibos(page, size, search, usuario, estado)),
});

const mapStateToProps = (state) => ({
  reporteReciboData: state.reporteReciboData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReporteRecibos);
